import { render, staticRenderFns } from "./Rotator4.vue?vue&type=template&id=a6e778d6&scoped=true"
import script from "./Rotator4.vue?vue&type=script&lang=js"
export * from "./Rotator4.vue?vue&type=script&lang=js"
import style0 from "./Rotator4.vue?vue&type=style&index=0&id=a6e778d6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a6e778d6",
  null
  
)

export default component.exports